import React from "react";
import { Form } from "@redriver/cinnamon";
import { dropdownOrganisationsLookup } from "./actions";

const OrganisationTypeAhead = ({ ...props }) => {
  return <Form.TypeAhead {...props} lookup={dropdownOrganisationsLookup} />;
};

export default OrganisationTypeAhead;
